// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"1d0443b7","162":"d8c1e99d","171":"c9630be7","261":"5a68ff92"}[chunkId] + ".chunk.js";
};